import { Injectable, AfterViewInit, OnInit } from '@angular/core';
declare var $: any; 

@Injectable({
  providedIn: 'root'
})
export class HelperService implements AfterViewInit, OnInit {

  windowScrolled: boolean | undefined;
  constructor() { }
  // Sticky Nav
  // @HostListener("window:scroll", [])
  // onWindowScroll() {
  //     if (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop > 600) {
  //         this.windowScrolled = true;
  //     } 
  //    else if (this.windowScrolled && window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop < 600) {
  //         this.windowScrolled = false;
  //     }
  // }
  // navigation
  navmethod: boolean = false;
  toggleNav() {
    this.navmethod = !this.navmethod;
  }
  //Mobile 
  open: boolean = false;
  trigger(item: { open: boolean; }) {
    item.open = !item.open;
  }
  // Search
  searchMethod: boolean = false;
  toggleSearch() {
    this.searchMethod = !this.searchMethod;
  }
  // Canvas
  canvasMethod: boolean = false;
  toggleCanvas() {
    this.canvasMethod = !this.canvasMethod;
  }
  // Cart
  cartMethod: boolean = false;
  toggleCart() {
    this.cartMethod = !this.cartMethod;
  }
  ngOnInit(): void {

  }
  ngAfterViewInit(): void {
    // ($('.popup-youtube') as any).magnificPopup({
    //   type: 'iframe'
    // });
    // ($('.gallery-thumb') as any).magnificPopup({
    //   type: 'image',
    //   gallery: {
    //     enabled: true,
    //   },
    //   mainClass: 'mfp-fade',
    // });
  }
}
